
import { IObservableValue, observable } from "mobx";
import { IMessageBus } from "..";
import { InternalMessageBusChannels } from "sb-resp-lib";

type timeZoneAction = (timeZone: number) => Promise<any>;
type timezoneMessage = { currentSelectedTimeZone: number };

export interface ITimeZoneObservable {
    observe(action:timeZoneAction): Promise<any>;
    activate(): void;
    deactivate(): void;
}

export class TimeZoneObservable implements ITimeZoneObservable {
    private readonly messageBus: IMessageBus;
    private readonly observers :(() => void)[] = [];
    private readonly currentTimeZone: IObservableValue<number> = observable.box(0);
    private subscription = () => {};

    constructor(messageBus: IMessageBus) {
        this.messageBus = messageBus;
        this.messageBus.emit(InternalMessageBusChannels.legacy.timeZone.request, { callback: (message: timezoneMessage) => this.updateTimeZone(message) });
    }

    activate() {
        this.subscription = this.messageBus.getSubscription<timezoneMessage>(InternalMessageBusChannels.legacy.timeZone.update,
            (message) => this.updateTimeZone(message.data[0]), this);
    }

    async observe(action: timeZoneAction) {
        await action(this.currentTimeZone.get());
        this.observers.push(this.currentTimeZone.observe((change) => action(change.newValue)))
    }

    private updateTimeZone(message: timezoneMessage) {
        this.currentTimeZone.set(message.currentSelectedTimeZone);
    }

    deactivate() {
        this.subscription();
        this.observers.forEach(x => x());
        this.observers.splice(0,this.observers.length);
    }
}